function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2017 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * Returns all attached overlays in visual stacking order.
 * @private
 */
var getAttachedInstances = function getAttachedInstances() {
  return Array.from(document.body.children).filter(function (el) {
    return el instanceof HTMLElement && el._hasOverlayStackMixin && !el.hasAttribute('closing');
  }).sort(function (a, b) {
    return a.__zIndex - b.__zIndex || 0;
  });
};
/**
 * Returns true if the overlay is the last one in the opened overlays stack.
 * @param {HTMLElement} overlay
 * @return {boolean}
 * @protected
 */


export var isLastOverlay = function isLastOverlay(overlay) {
  return overlay === getAttachedInstances().pop();
};
/**
 * @polymerMixin
 */

export var OverlayStackMixin = function OverlayStackMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(OverlayStackMixin, _superClass);

    var _super = _createSuper(OverlayStackMixin);

    function OverlayStackMixin() {
      var _this;

      _classCallCheck(this, OverlayStackMixin);

      _this = _super.call(this);
      _this._hasOverlayStackMixin = true;
      return _this;
    }
    /**
     * Returns true if this is the last one in the opened overlays stack.
     *
     * @return {boolean}
     * @protected
     */


    _createClass(OverlayStackMixin, [{
      key: "_last",
      get: function get() {
        return isLastOverlay(this);
      }
      /**
       * Brings the overlay as visually the frontmost one.
       */

    }, {
      key: "bringToFront",
      value: function bringToFront() {
        var _this2 = this;

        var zIndex = '';
        var frontmost = getAttachedInstances().filter(function (o) {
          return o !== _this2;
        }).pop();

        if (frontmost) {
          var frontmostZIndex = frontmost.__zIndex;
          zIndex = frontmostZIndex + 1;
        }

        this.style.zIndex = zIndex;
        this.__zIndex = zIndex || parseFloat(getComputedStyle(this).zIndex);
      }
      /** @protected */

    }, {
      key: "_enterModalState",
      value: function _enterModalState() {
        var _this3 = this;

        if (document.body.style.pointerEvents !== 'none') {
          // Set body pointer-events to 'none' to disable mouse interactions with
          // other document nodes.
          this._previousDocumentPointerEvents = document.body.style.pointerEvents;
          document.body.style.pointerEvents = 'none';
        } // Disable pointer events in other attached overlays


        getAttachedInstances().forEach(function (el) {
          if (el !== _this3) {
            el.$.overlay.style.pointerEvents = 'none';
          }
        });
      }
      /** @protected */

    }, {
      key: "_exitModalState",
      value: function _exitModalState() {
        if (this._previousDocumentPointerEvents !== undefined) {
          // Restore body pointer-events
          document.body.style.pointerEvents = this._previousDocumentPointerEvents;
          delete this._previousDocumentPointerEvents;
        } // Restore pointer events in the previous overlay(s)


        var instances = getAttachedInstances();
        var el; // Use instances.pop() to ensure the reverse order

        while (el = instances.pop()) {
          if (el === this) {
            // Skip the current instance
            continue;
          }

          el.$.overlay.style.removeProperty('pointer-events');

          if (!el.modeless) {
            // Stop after the last modal
            break;
          }
        }
      }
    }]);

    return OverlayStackMixin;
  }(superClass);
};